module.exports = __webpack_public_path__ + "img/ye.eab42b4d.svg";